import { Separator } from '@/components/ui/separator'
import OverviewTable from './(components)/overview-table'
import { Button } from '@/components/ui/button'
import * as Icons from 'lucide-react'
import CreateContact from '@/components/features/contacts/create'
import { useQueryClient } from '@tanstack/react-query'

const ContactsPage = () => {
    const queryClient = useQueryClient();
  return (
    <div className='p-4 space-y-4 h-full flex flex-col justify-between overflow-auto'>
      <header className='flex items-center justify-between'>
        <h1 className='text-3xl font-bold'>Contacten</h1>
        <CreateContact 
            onCreated={()=>{
                queryClient.invalidateQueries({ queryKey: ['contacts'] });
            }}
            trigger={
                <Button variant='bright'>
                    <Icons.Plus className="w-4 h-4"/>
                    Nieuw contact
                </Button>
            }
        />
        
      </header>

      <Separator />

      <OverviewTable />
    </div>
  )
}

export default ContactsPage